import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography,
  Chip
} from '@material-ui/core';

import { green, red } from '@material-ui/core/colors';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import BuildIcon from '@material-ui/icons/Build';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  sit0: {
    color: colors.red[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit1: {
    color: colors.yellow[800],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit2: {
    color: colors.green[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  }
}));

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, situations }) => {

  const classes = useStyles();

  const formatDecimal = (value) => {
    return numeral(value).format('0.00').replace('.', ',');
  }

  const formatNumber = (value, mask) => {
    return numeral(value).format(mask);
  }

  const formatDate = (value) => {
    if (value) {
      return moment(value).format('DD/MM/YYYY')
    } else {
      return ""
    }
  }

  const truncateValue = (value, size) => {
    if (value.length > size) {
      return value.substring(size - 3, 0) + '...';
    } else {
      return value;
    }
  }

  const calculaSituacaoComprovantes = (value) => {
    return 1
  }

  const calculaSituacaoAnalise = (item) => {
    if (item.conta.abertos > 0) {
      return 0
    } else {
      return 1
    }
  }

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (resultMode.update + resultMode.delete + resultMode.config) * 150;
    return { maxWidth: distance, minWidth: distance };
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
                component={Link}
                onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
              >
                <Avatar
                  className={classes.avatar}
                >
                  {<Icon component={icon} style={{ color: colors.green[600] }} ></Icon>}
                </Avatar>
                {getFieldValue(col)}
              </Box>
            </TableCell>

          ) : (
            <TableCell >

              {(col.name == 'Saldo') ?
                <Chip variant="default" style={(parseFloat(getFieldValue(col)) == 0.0) ? {} : (parseFloat(getFieldValue(col)) > 0.0) ? { color: 'white', backgroundColor: green[500] } : { color: 'white', backgroundColor: red[500] }}
                  size="medium"
                  label={getFieldValue(col)} ></Chip>
                :
                <Typography variant="body" noWrap={(col.wrap)} className={(index == 6) ? calculaSituacaoComprovantes(getFieldValue(col)) == 0 ? classes.sit0 : calculaSituacaoComprovantes(getFieldValue(col)) == 1 ? classes.sit1 : calculaSituacaoComprovantes(getFieldValue(col)) == 2 ? classes.sit2 : "" : (index == 4 || index == 5) ? calculaSituacaoAnalise(item) == 0 ? classes.sit0 : "" : ""} >
                  {getFieldValue(col)}
                </Typography>
              }


            </TableCell>)
        ))}

        <TableCell align="right" >
          <Grid container style={getStyleActionsAjustment(resultMode)} >
            {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Tratar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.config == LEVEL_ACCESS_DISABLED}
                    children={<BuildIcon />}
                    size="medium"
                    onClick={() => { openTreatment(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Editar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.update == LEVEL_ACCESS_DISABLED}
                    children={<EditRoundedIcon />}
                    size="medium"
                    onClick={() => { openEdition(item) }}>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title={"Excluir"}>
                  <IconButton
                    color="secondary"
                    disabled={resultMode.delete == LEVEL_ACCESS_DISABLED || (item.operacao == 1 && (localStorage.getItem('profile') != 'ADM' && localStorage.getItem('profile') != 'ENG'))}
                    children={<DeleteRoundedIcon />}
                    size="medium"
                    onClick={() => { openDeletion(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

          </Grid>
        </TableCell>

      </TableRow>

    </Fragment >
  );
}

export default Record;